import { useTranslation } from 'react-i18next'

import { Checkbox } from '@reveni-io/reveni-ui'

import { preferences } from '@/configuration/pages/ConfigurationPage/constants'
import { exchangeOrdersAutomaticCreationValues } from '@/configuration/pages/ConfigurationPage/ReturnPolicy/ReturnPolicyConfiguration/constants'
import { providers } from '@/returns/constants'

const InstantExchangeSendProviderNotificationCheckbox = ({
  checked,
  onChange,
  allowedPreferences,
  instantExchangeOrdersAutomaticCreation,
  provider,
  disabled,
}) => {
  const { t } = useTranslation()

  if (
    !allowedPreferences.includes(preferences.instantExchangeOrdersAutomaticCreation) ||
    instantExchangeOrdersAutomaticCreation !== exchangeOrdersAutomaticCreationValues.automatic ||
    !allowedPreferences.includes(preferences.instantExchangeOrdersSendProviderNotification) ||
    provider !== providers.shopify
  ) {
    return null
  }

  return (
    <Checkbox
      label={t('Permitir que Shopify envíe email de confirmación del nuevo pedido')}
      checked={checked}
      onChange={e => onChange(e.target.checked)}
      disabled={disabled}
    />
  )
}

export default InstantExchangeSendProviderNotificationCheckbox
